export default __webpack_public_path__ + "static/media/filter.08757fd0.svg";